import { Provider } from "react-redux";
import SalesForm from "./SalesForm";

interface SalesFormAppProps {
  CHARGIFY_SITE: string;
  CHARGIFY_JS_PUBLIC_KEY: string;
}

const SalesFormApp = ({ CHARGIFY_SITE, CHARGIFY_JS_PUBLIC_KEY }: SalesFormAppProps) => (
  <Provider store={ReactOnRails.getStore("layoutStore")}>
    <SalesForm CHARGIFY_SITE={CHARGIFY_SITE} CHARGIFY_JS_PUBLIC_KEY={CHARGIFY_JS_PUBLIC_KEY} />
  </Provider>
);

export default SalesFormApp;
